import { useEffect, useRef } from "react";
import Markdown from "react-markdown";

const AiChatTypingText = ({
  text,
  speed = 25,
  onComplete,
  displayed,
  setDisplayed,
  displayedLengthRef,
  intervalRef,
}) => {
  const prevTextRef = useRef("");

  useEffect(() => {
    const prevText = prevTextRef.current;

    // If text is an extension of previous text → continue typing
    const isExtension = text.startsWith(prevText);

    if (!isExtension) {
      // completely new message → reset
      displayedLengthRef.current = 0;
      setDisplayed("");
    }

    prevTextRef.current = text;

    // clear existing interval safely
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (!text) return;

    intervalRef.current = setInterval(() => {
      displayedLengthRef.current += 1;

      const next = text.slice(0, displayedLengthRef.current);
      setDisplayed(next);

      if (displayedLengthRef.current >= text.length) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        onComplete?.();
      }
    }, speed);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [text, speed, onComplete]);

  return <Markdown>{displayed}</Markdown>;
};

export default AiChatTypingText;
